/* istanbul ignore file */
export { default } from './NavMenu';
